interface StackedLibrariesGlyphProps {
  size?: number;
}

const StackedLibrariesGlyph = ({ size = 260 }: StackedLibrariesGlyphProps) => (
  <svg
    width={size}
    height={size * 0.72}
    viewBox="0 0 340 244"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect
      x="40"
      y="56"
      width="180"
      height="150"
      rx="14"
      fill="#E5EEFF"
      stroke="#0047D4"
      strokeOpacity=".15"
      strokeWidth="1"
      transform="rotate(-8 130 131)"
    />
    <rect
      x="80"
      y="46"
      width="180"
      height="150"
      rx="14"
      fill="#F3F3F3"
      stroke="#DCDCDC"
      strokeWidth="1"
    />
    <g transform="rotate(6 220 128)">
      <rect x="130" y="50" width="180" height="150" rx="14" fill="#0047D4" />
      <g transform="translate(168 96)" fill="#fff">
        <rect x="0" y="0" width="14" height="56" rx="2" opacity=".9" />
        <rect x="20" y="8" width="14" height="48" rx="2" opacity=".75" />
        <rect x="40" y="0" width="14" height="56" rx="2" opacity=".6" />
        <rect x="60" y="16" width="14" height="40" rx="2" opacity=".9" />
        <rect x="80" y="6" width="14" height="50" rx="2" opacity=".5" />
        <rect x="100" y="12" width="14" height="44" rx="2" opacity=".8" />
      </g>
      <rect
        x="146"
        y="66"
        width="34"
        height="22"
        rx="4"
        fill="#fff"
        opacity=".25"
      />
    </g>
    <g
      stroke="#0047D4"
      strokeWidth="1.5"
      strokeDasharray="3 4"
      opacity=".5"
      fill="none"
    >
      <path d="M70 40 Q 170 0 285 38" />
    </g>
    <circle cx="70" cy="40" r="6" fill="#0047D4" />
    <circle cx="70" cy="40" r="2.5" fill="#fff" />
    <circle cx="285" cy="38" r="6" fill="#0047D4" />
    <circle cx="285" cy="38" r="2.5" fill="#fff" />
    <circle cx="177" cy="16" r="5" fill="#0047D4" opacity=".7" />
  </svg>
);

export default StackedLibrariesGlyph;
